import { css } from '@emotion/css'
import { spacing, accessiblyHidden, mediaQueryHelper, breakpoint } from '@offerzen/pinata-shame'

const styles = {
  card: css({
    padding: spacing.default,
    marginBottom: spacing.large,
  }),

  jobForm: css({
    display: 'grid',
    rowGap: spacing.default,
    width: '100%',
    [mediaQueryHelper(breakpoint.phone)]: {
      gridTemplateColumns: '1fr max-content',
      columnGap: spacing.default,
    },
  }),

  accessiblyHidden: css(accessiblyHidden),

  input: css({
    width: '100%',
  }),
}

export default styles
